import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getBrandList } from "../../services/super-admin.service";
import { useNavigate } from "react-router-dom";

import AddIcon from "../../assets/images/add_icon.svg";
import UpdateIcon from "../../assets/images/update_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import DeleteIcon from "../../assets/images/delete_icon.svg";

import CashBackPriority from "./CashBackPriority";
import CreateProduct from "./CreateProduct";
import Editcashbackrule from "./Editcashbackrule";
import ViewProduct from "./ViewProduct";
import setting from "../../assets/images/setting_icon.svg";
import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";
import PaginatedTable from "../common/PaginatedTable";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import CloseIcon from "../../assets/images/close_icon.svg";
import SelectdateIcon from "../../assets/images/selectdate_icon.svg";
import { formatCurrency } from "../../utils/helpers/helper";
import { useTranslation } from 'react-i18next';  

import EditBrandForm from "./EditBrandForm";
// import ViewCashbank from "./ViewCashbank";
import {
  getProduct,
  // updateCashBackRules,
  // removeCashBackRules
} from "../../services/product.services";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRole } from "../../store/role/role.selector";

const ProductManagement = ({ backFunc }) => {
  const { id } = useParams();
  const [createForm, setCreateForm] = useState(false);
  const [brandTable, setBrandTable] = useState(true);
  const [createcashproform, setcashproform] = useState(false);
  const [cashbackview, setcashbackview] = useState(false);
  const { t, i18n } = useTranslation(); // Translation hook

  const [Ediform, setEdiform] = useState(false);
  const [product, setproduct] = useState();
  const [status, setStatus] = useState("");
  console.log("product::: ", product);

  const role = useSelector(selectRole);

  //pagination
  // const [Viewtransaction, setViewtransaction] = useState(false);
  const [TransactionTable, setTransactioTable] = useState(true);
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [range, setRange] = useState({
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
  });

  const [isOpen, setIsOpen] = useState(false);
  const handleTogglePicker = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (ranges) => {
    const temp = {
      startDate: ranges["range1"]["startDate"],
      endDate: ranges["range1"]["endDate"],
    };
    setRange(temp);
  };

  const [data, setData] = useState({});
  const navigate = useNavigate();
  const handleShow = () => {
    setCreateForm(true);
    setBrandTable(false);
    setcashproform(false);
  };

  const showPriority = () => {
    setCreateForm(false);
    setBrandTable(false);
    setcashproform(true);
  };

  const back = (list = true) => {
    list && getallproduct(id);
    setBrandTable(true);
    setEdiform(false);
    setCreateForm(false);
    setcashproform(false);
    setcashbackview(false);
    setData({});
  };

  const handleShowedit = (product) => {
    setData(product);
    // setcashproform(true);
    setEdiform(true);
    setBrandTable(false);
  };

  // const handleView = (brand) => {
  //   setData(brand);
  //   setEdiform(true);
  //   setBrandTable(false);
  // };

  const handleShowView = (product) => {
    setData(product);
    setcashbackview(true);
    setBrandTable(false);
    // setcashbackview(true);
  };

  const getallproduct = async (id) => {
    try {
      const requestBody = {
        offset: (currentPage - 1) * itemsPerPage,
        limit: itemsPerPage,
        search: searchKey,

        brand_id: id,
        startDate: range.startDate,
        endDate: range.endDate,

        statusfilter: status || "all",

        // search:undefined
      };
      const resp = await getProduct(id, requestBody);
      console.log("resp::: ", resp);

      if (resp?.status === 200 && resp?.data?.statusCode === 200) {
        setproduct(resp?.data?.data);
        setTotalCount(resp?.data?.count);
      } else {
        // toast.error(resp?.message || resp?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();

        console.error(msg);
      }
      console.log(error.message);
    }
  };

  // const cashbackStatusUpdate = async (brand) => {

  //   try {
  //     const payload = {
  //       rules_id: brand?.id,
  //       status: !brand?.active_flag,
  //     };

  //     const res = await updateCashBackRules(payload);

  //     if (res?.status === 200 && res?.data?.statusCode === 200) {

  //       toast.success(res?.data?.message);
  //       back();
  //     } else {
  //       toast.error(res?.message || res?.data?.message);
  //     }
  //   } catch (error) {
  //     console.error("Error occurred while updating brand status:", error);
  //   }
  // };

  // const deleteVoucher = async (id) => {

  //   try {
  //     const payload = {
  //       id: id,
  //     }
  //     const res = await removeCashBackRules(payload);
  //     if (res?.status === 200 && res?.data?.statusCode === 200) {
  //       toast?.success(res?.data?.message);
  //       back()
  //     } else {
  //       toast.error(res?.message || res?.data?.message);
  //     }
  //   } catch (error) {

  //   }

  // }

  const [column, setColumn] = useState([
    {
      heading: () => t("common.Action"),
      cell: (row) => (
        <img
          src={ViewIcon}
          alt="ViewIcon"
          onClick={() => handleShowView(row)}
        />
      ),
      hidden: false,
      width: "120",
      align: "left",
      id: 9,
    },
    {
      heading: () => t("merchant.ProductLogo"),
      cell: (row) => (
        <div>
          {row.logo ? (
            <img src={row.logo} alt="Currency Logo" width={60} />
          ) : (
            "-"
          )}
        </div>
      ),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },

    {
      heading: () => t("merchant.ProductName"),
      cell: (row) => (row["product_name"] ? row["product_name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 6,
    },
    {
      heading: () => t("merchant.UPC"),
      cell: (row) => (row["upc"] ? row["upc"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 5,
    },
    {
      heading: () => t("merchant.SKU"),
      cell: (row) => (row["sku"] ? row["sku"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 4,
    },
    // {
    //   heading: () => "Available Quantity",
    //   cell: (row) => (row["start_Date"] ? row["start_Date"] : "-"),
    //   hidden: false,
    //   width: "120",
    //   align: "left",
    //   id: 7,
    // },

    // {
    //   heading: () => "End Date",
    //   cell: (row) => (row["end_Date"] ? row["end_Date"] : "-"),
    //   hidden: false,
    //   width: "120",
    //   align: "left",
    //   id: 9,
    // },
    {
      heading: () => t("common.Status"),
      cell: (row) => {
        console.log("row::: ", row);
        const status = row["active_flag"];
        console.log("status::: ", status);
        let displayText = "";
        let style = {};
        let className = "";

        if (status === true) {
          displayText = "Active";
        } else if (status === false) {
          displayText = "InActive";
          className = "fontWeight600 errorClr_text"; // Use class names directly
        } else if (status === "all") {
          displayText = "ALL Status";
          style = { color: "#28a745", fontWeight: 600 };
        } else {
          displayText = "-";
          style = { fontWeight: 600 };
        }

        return (
          <span
            className={
              row?.active_flag
                ? "fontWeight600 UFOGreen_text"
                : "fontWeight600 errorClr_text"
            }
            style={style}
          >
            {displayText}
          </span>
        );
      },
      hidden: false,
      width: "120",
      align: "left",
      id: 8,
    },
  ]);

  useEffect(() => {
    getallproduct(id);
  }, [currentPage, itemsPerPage, searchKey, range, setSearchKey, status]);

  const handleBack = () => {
    if (createcashproform || cashbackview || createForm) {
      back();
    } else {
      backFunc();
    }
  };

  return (
    <div>
      <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween BorderBottom_LavenderSyrup pb_16 Mob_flexWrapGap">
        <div className="displayFlex alignItem_center gap12">
          <div>
            <button className="emptyBtn" onClick={handleBack}>
              <img src={ArrowleftIcon} alt="ArrowleftIcon" />
            </button>
          </div>
          <div>
            <h5 className="fontSize20 fontWeight600 blackClr_text">
              {"Products Management"}
            </h5>
          </div>
        </div>

        {/* <div className="displayFlex alignItem_center gap12">


          <div>
            <button
              className="MainButton lemonPie_clr gap8"
              type="button"
              onClick={() => showPriority()}
            >
              <img className="width20px" src={setting} alt="setting" />
              <span> Setting </span>
            </button>
          </div>


        </div> */}
      </div>
      {!cashbackview && !Ediform && !createForm && (
        <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween Mob_flexWrapGap">
          <div>
            <h5 className="fontSize16 fontWeight600 blackClr_text">
            {t("merchant.ProductList")}
            </h5>
          </div>
          <div className="displayFlex alignItem_center gap12">
            {role == "merchant" ? (
              ""
            ) : (
              <div>
                <button
                  className="MainButton cyanSky_clr gap8"
                  type="button"
                  onClick={handleShow}
                  // onClick={() => navigate("/add-coach")}
                >
                  <img className="width20px" src={AddIcon} alt="AddIcon" />
                  <span> {t("merchant.CreateProduct")} </span>
                </button>
              </div>
            )}
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                {/* All Transactions List */}
              </h5>
            </div>
            {/* <div className="position_relative">
             <button
               className="lemonPie_clr MainButton gap12"
               onClick={handleTogglePicker}
             >
               <img className='width20px' src={SelectdateIcon} />
               <span>Select date</span>
             </button>
             {isOpen && (
               <div className="DateRangePickerPosition">
                 <DateRangePicker ranges={[range]} onChange={handleSelect} />
                 <button
                   className="closeDateRangePicker"
                   onClick={handleTogglePicker}
                 >
                   <img src={CloseIcon} alt="CloseIcon" />
                 </button>
               </div>
             )}
           </div> */}
          </div>
        </div>
      )}

      {brandTable && (
        <>
          {isLoading ? (
            <PaginatedTable
              row={product}
              column={column}
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isSearch={true}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              maxPageNumberLimit={maxPageNumberLimit}
              setMaxPageNumberLimit={setMaxPageNumberLimit}
              minPageNumberLimit={minPageNumberLimit}
              setMinPageNumberLimit={setMinPageNumberLimit}
              isExport={false}
              status={status}
              setStatus={setStatus}
              isstatus={true}
            />
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </>
      )}

      {createForm && <CreateProduct data={product} back={back} />}

      {createcashproform && <CashBackPriority editData={data} back={back} />}

      {cashbackview && (
        <ViewProduct
          brand={product}
          back={back}
          handleShowedit={handleShowedit}
          handleShowView={handleShowView}
        />
      )}
    </div>
  );
};

export default ProductManagement;
